import { render, staticRenderFns } from "./OperaModuleFieldConfigWindow.vue?vue&type=template&id=fbf5b5d2&scoped=true&"
import script from "./OperaModuleFieldConfigWindow.vue?vue&type=script&lang=js&"
export * from "./OperaModuleFieldConfigWindow.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fbf5b5d2",
  null
  
)

export default component.exports